const clientSideValidation = require('../components/clientSideValidation');
const dropzone = require('../components/dropzone');

const FORM_SELECTOR = '.complaint-form';
const SUBMIT_BUTTON_SELECTOR = '.complaint-form__submit-button';

/**
 * Manages the complaint form error
 * @param {Object} data Data received from the server
 * @param {Object} [data.fieldErrors] Errors by field
 * @param {Object} [data.msg] General error message to show
 */
function manageFormError(data) {
  const formUtils = require('../common/utils/formUtils');
  if (data.fieldErrors?.length) {
    data.fieldErrors.forEach((error) => {
      if (Object.keys(error).length) {
        formUtils.loadFormErrors('.complaint-form', error);
      }
    });
  }

  if (data.msg) {
    if ($('.form-general-error').length === 0) {
      $('.form.contact-form').append(
        '<p class="form-general-error form-invalid-feedback"></p>'
      );
    }
    $('.form-general-error').text(data.msg);
  }
}

/**
 * Manages the complaint form success
 * @param {HTMLElement} form Complaint form element
 * @param {HTMLElement} button Complaint submit button element
 */
function manageFormSuccess(form, button) {
  $('body').trigger('interaction--swap-text-event', button);
  // eslint-disable-next-line no-param-reassign
  button.disabled = false;
  form.reset();
}

/**
 * Handle the dropzone success event response
 * @param {Event} event Dropzone success event
 */
function handleDropzoneSuccess(event) {
  const response = event.detail;
  if (response.error) {
    manageFormError(response);
  } else {
    const form = document.querySelector(FORM_SELECTOR);
    const button = form.querySelector(SUBMIT_BUTTON_SELECTOR);
    manageFormSuccess(form, button);
  }
  grecaptcha.reset();
}

/**
 * Validates the complaint form business data
 * @returns {boolean} True if business data is valid, false otherwise
 */
function validateBusinessData() {
  let isValid = true;

  const email = document.getElementById('email');
  const confirmEmail = document.getElementById('confirm-email');
  if (email.value !== confirmEmail.value) {
    const errorMessage = confirmEmail.getAttribute(
      'data-repeat-mismatch-error'
    );
    document.getElementById('confirm-email-error').innerText = errorMessage;
    isValid = false;
  }

  const comment = document.getElementById('comment');
  if (comment.value === '' || comment.classList.contains('is-empty')) {
    comment.classList.add('is-invalid');
    comment.nextElementSibling.innerText = comment.dataset.missingError;
    isValid = false;
  }

  if (!isValid) {
    return false;
  }

  // At this point all validations passed but need recaptcha to let us go through.
  // CASE 2: If we don't have a recaptcha response value yet in the hidden field,
  // we will need to execute it and wait for a response.
  // CASE 1: The callback defined in the isml will submit the form again when gets response,
  // which will run this same function again, this time returning true below.

  // CASE 1 Callback returned, added value to hiddenRecaptcha and triggered submit again
  if (document.querySelector('.hiddenRecaptcha').value !== '') {
    return true;
  }

  // CASE 2 Callback not returned, execute and stop for submission now:
  grecaptcha.execute();
  return false;
}

/**
 * Calls the complaint form action url & handles the response
 * @param {HTMLElement} form Complaint Form element
 */
function doSubmit(form) {
  const button = form.querySelector(SUBMIT_BUTTON_SELECTOR);
  const url = form.getAttribute('action');

  button.disabled = true;

  if (dropzone.methods.processFiles()) {
    return;
  }

  const formData = new FormData(form);
  fetch(url, {
    method: 'POST',
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      if (!data.success) {
        manageFormError(data);
      } else {
        manageFormSuccess(form, button);
      }
    })
    .catch((error) => {
      manageFormError(error);
    })
    .finally(() => {
      grecaptcha.reset();
    });
}

/**
 * Handles the complaint form submit event
 * @param {Event} event Form submit event
 */
function handleSubmit(event) {
  event.preventDefault();

  const form = document.querySelector(FORM_SELECTOR);
  const submitButton = form.querySelector(SUBMIT_BUTTON_SELECTOR);
  if (submitButton.disabled) {
    return;
  }

  const isFormatValid = clientSideValidation.functions.validateFormatData(form);
  if (isFormatValid) {
    const isBusinessValid = validateBusinessData();
    if (isBusinessValid) {
      doSubmit(form);
    }
  }
}

module.exports = {
  initDropzone() {
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    document.addEventListener('dropzone-success', handleDropzoneSuccess);

    // eslint-disable-next-line listeners/no-missing-remove-event-listener, listeners/no-inline-function-event-listener
    document.addEventListener('dropzone-error', () => {
      grecaptcha.reset();
    });

    const complaintDropzone = document.getElementById('complaint-image');
    const complaintSubmitButton = document.querySelector(
      SUBMIT_BUTTON_SELECTOR
    );
    dropzone.init(complaintDropzone, complaintSubmitButton);
  },
  initPrefixSelector() {
    require('../components/ds/forms/country-prefix-selector').init();
  },
  listenSubmit() {
    const form = document.querySelector(FORM_SELECTOR);
    if (!form) return;
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    form.addEventListener('submit', handleSubmit);
  },
};
